<template>
  <div>
    <div class="card-container shadow tab-container-questions">
      <div class="card-left">
        <div class="pl-3" @click="open">
          <em
            v-if="!isOpen"
            class="fas fa-plus-circle rounded-circle shadow color-icon-plus custom-design"
          />
          <em
            v-else
            class="fas fa-minus-circle rounded-circle shadow text-orange custom-design"
          />
        </div>

        <h5 class="pl-4 pt-2">
          {{ name }}
        </h5>
      </div>
      <div v-if="isDraft && canDelete" class="card-right">
        <em class="far fa-times-circle text-red " @click="deleteClick()" />
      </div>
    </div>
    <div v-if="isOpen">
      <div v-if="id == peiAssistantsNeeds.alimentacion">
        <QuestionAlimentation
          :validate="validate"
          :isReadonly="!isDraft"
          :removeColHeader="removeColHeader"
          :peiId="peiId"
          @save-questions="
            (e) =>
              onSaveHandler({ ...e, peiCode: peiAssistantsNeeds.alimentacion })
          "
        />
      </div>
      <div v-if="id == peiAssistantsNeeds.movilidad">
        <QuestionMobility
          :validate="validate"
          :isReadonly="!isDraft"
          :removeColHeader="removeColHeader"
          :peiId="peiId"
          @save-questions="
            (e) =>
              onSaveHandler({ ...e, peiCode: peiAssistantsNeeds.movilidad })
          "
        />
      </div>
      <div v-if="id == peiAssistantsNeeds.higiene">
        <QuestionsHygiene
          :validate="validate"
          :isReadonly="!isDraft"
          :removeColHeader="removeColHeader"
          :peiId="peiId"
          @save-questions="
            (e) => onSaveHandler({ ...e, peiCode: peiAssistantsNeeds.higiene })
          "
        />
      </div>
      <div v-if="id == peiAssistantsNeeds.transportacion">
        <QuestionTransportation
          :validate="validate"
          :isReadonly="!isDraft"
          :removeColHeader="removeColHeader"
          :peiId="peiId"
          @save-questions="
            (e) =>
              onSaveHandler({
                ...e,
                peiCode: peiAssistantsNeeds.transportacion,
              })
          "
        />
      </div>
      <div v-if="id == peiAssistantsNeeds.cateterizacion">
        <QuestionCatheterization
          :validate="validate"
          :isReadonly="!isDraft"
          :removeColHeader="removeColHeader"
          :peiId="peiId"
          @save-questions="
            (e) =>
              onSaveHandler({
                ...e,
                peiCode: peiAssistantsNeeds.cateterizacion,
              })
          "
        />
      </div>
      <div v-if="id == peiAssistantsNeeds.colonostomia">
        <QuestionColonostomy
          :validate="validate"
          :isReadonly="!isDraft"
          :removeColHeader="removeColHeader"
          :peiId="peiId"
          @save-questions="
            (e) =>
              onSaveHandler({ ...e, peiCode: peiAssistantsNeeds.colonostomia })
          "
        />
      </div>
      <div v-if="id == peiAssistantsNeeds.gastrostomía">
        <QuestionGastrostomy />
      </div>
      <div
        v-if="
          id == peiAssistantsNeeds.medicacion ||
            id == peiAssistantsNeeds.medicacionV2
        "
      >
        <QuestionMedication
          :validate="validate"
          :isReadonly="!isDraft"
          :removeColHeader="removeColHeader"
          :peiId="peiId"
          @save-questions="(e) => onSaveHandler({ ...e, peiCode: id })"
        />
      </div>
      <div v-if="id == peiAssistantsNeeds.interpretacion">
        <QuestionInterpretation
          :validate="validate"
          :isReadonly="!isDraft"
          :removeColHeader="removeColHeader"
          :peiId="peiId"
          @save-questions="
            (e) =>
              onSaveHandler({
                ...e,
                peiCode: peiAssistantsNeeds.interpretacion,
              })
          "
        />
      </div>
      <div v-if="id == peiAssistantsNeeds.sillaDeRueda">
        <QuestionWheelCHair
          :validate="validate"
          :isReadonly="!isDraft"
          :removeColHeader="removeColHeader"
          :peiId="peiId"
          @save-questions="
            (e) =>
              onSaveHandler({ ...e, peiCode: peiAssistantsNeeds.sillaDeRueda })
          "
        />
      </div>
      <div v-if="id == peiAssistantsNeeds.ansiedadSevera">
        <QuestionAnxiety
          :validate="validate"
          :isReadonly="!isDraft"
          :removeColHeader="removeColHeader"
          :peiId="peiId"
          @save-questions="
            (e) =>
              onSaveHandler({
                ...e,
                peiCode: peiAssistantsNeeds.ansiedadSevera,
              })
          "
        />
      </div>
      <div v-if="id == peiAssistantsNeeds.apoyoConductual">
        <QuestionsConductualSupport
          :validate="validate"
          :isReadonly="!isDraft"
          :removeColHeader="removeColHeader"
          :peiId="peiId"
          :studentSieId="studentId"
          :inappropriate-conduct-alternative="inappropriateConductAlternative"
          @save-questions="
            (e) =>
              onSaveHandler({
                ...e,
                peiCode: peiAssistantsNeeds.apoyoConductual,
              })
          "
        />
      </div>
      <div v-if="hasAdditionalQuestions" class="bg-secondary-3">
        <AdditionalQuestion
          v-for="question in additionalQuestions"
          :key="question.id"
          :question="question"
          :validate="validate"
          :isReadonly="!isDraft"
          :removeColHeader="removeColHeader"
          :peiId="peiId"
        />

        <div class="d-flex justify-content-end p-4">
          <action-button
            v-if="isDraft"
            type="button"
            text="Guardar"
            i="fa fa-save pr-2"
            variant="success"
            @click="onSaveAdditionalQuestions"
          />
        </div>
      </div>
    </div>
    <Error
      v-if="showIncompleteError"
      message="Falta información de documentar. (5018)"
      class="my-2"
      variant="no-border"
    />
  </div>
</template>

<script>
import peiAssistantsNeeds from '@/utils/constants/pei/peiAssistantsNeeds';
import QuestionAlimentation from '@/components/pei/tabs/components/tab6/questionAssistant/QuestionAlimentation.vue';
import AdditionalQuestion from '@/components/pei/tabs/components/tab6/questionAssistant/AdditionalQuestion.vue';
import QuestionCatheterization from '@/components/pei/tabs/components/tab6/questionAssistant/QuestionCatheterization.vue';
import QuestionColonostomy from '@/components/pei/tabs/components/tab6/questionAssistant/QuestionColonostomy.vue';
import QuestionGastrostomy from '@/components/pei/tabs/components/tab6/questionAssistant/QuestionGastrostomy.vue';
import QuestionsHygiene from '@/components/pei/tabs/components/tab6/questionAssistant/QuestionsHygiene.vue';
import QuestionInterpretation from '@/components/pei/tabs/components/tab6/questionAssistant/QuestionInterpretation.vue';
import QuestionMedication from '@/components/pei/tabs/components/tab6/questionAssistant/QuestionMedication.vue';
import QuestionTransportation from '@/components/pei/tabs/components/tab6/questionAssistant/QuestionTransportation.vue';
import QuestionWheelCHair from '@/components/pei/tabs/components/tab6/questionAssistant/QuestionWheelCHair.vue';
import QuestionAnxiety from '@/components/pei/tabs/components/tab6/questionAssistant/QuestionAnxiety.vue';
import QuestionMobility from '@/components/pei/tabs/components/tab6/questionAssistant/QuestionMobility.vue';
import QuestionsConductualSupport from '@/components/pei/tabs/components/tab6/questionAssistant/QuestionsConductualSupport.vue';
import needsService from '@/services/pei/serviceNeedQuestionnaire';
import store from '@/store/index';
import alert from '@/mixin/alert.mixin';
import AnswerType from '@/utils/constants/pei/serviceNeedQuestionnaire/answerType';
import ActionButton from 'ActionButton';
import Error from '@/components/common/Error';
import $ from 'jquery';

export default {
  name: 'HeaderAssistantQuestion',
  mixins: [alert],
  components: {
    QuestionAlimentation,
    AdditionalQuestion,
    QuestionCatheterization,
    QuestionColonostomy,
    QuestionGastrostomy,
    QuestionsHygiene,
    QuestionInterpretation,
    QuestionMedication,
    QuestionTransportation,
    QuestionWheelCHair,
    QuestionAnxiety,
    QuestionMobility,
    QuestionsConductualSupport,
    ActionButton,
    Error,
  },
  props: {
    name: {
      type: String,
      default: '',
      required: true,
    },
    id: {
      type: Number,
      default: '',
      required: true,
    },
    hasAnyAssistantServiceNeed: {
      type: Boolean,
      default: false,
      required: false,
    },
    isDraft: {
      type: Boolean,
      required: true,
    },
    canDelete: {
      type: Boolean,
      default: true,
    },
    justify: {
      type: Boolean,
    },
    peiId: {
      type: String,
      default: '',
    },
    removeColHeader: {
      type: Boolean,
      default: false,
    },
    validationMessage: {
      type: String,
      default: '',
    },
    validate: {
      type: Boolean,
    },
    inappropriateConductAlternative: {
      type: [String, Number],
      default: null,
    },
    additionalQuestions: {
      type: Array,
      default: () => [],
      required: false,
    },
    allAdditionalQuestions: {
      type: Array,
      default: () => [],
      required: false,
    },
    studentId: {
      type: Number,
      default: 0,
    },
    triggerScroll: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
      peiAssistantsNeeds: peiAssistantsNeeds,
      transportationQuestions: [],
    };
  },
  computed: {
    hasAdditionalQuestions() {
      return this.additionalQuestions.length > 0;
    },
    selectedPeiId() {
      return store.getters.SelectedPei;
    },
    showIncompleteError() {
      let disciplineId = this.id;
      if (this.id == 0) disciplineId = -1; //Id de preguntas adicionales
      return (
        this.validate &&
        store.getters.tab6Errors.some(
          (c) => c.id == `incomplete-${disciplineId}`
        )
      );
    },
    justifiedFlagChanged() {
      return (justified) => this.justify !== justified;
    },
    determinationText() {
      let text = 'Determinación: ';

      const isTransportacion =
        this.id === this.peiAssistantsNeeds.transportacion;

      if (isTransportacion) {
        if (!this.hasAnsweredTransportationQuestions) {
          text += 'No se justifica';
        } else {
          text += this.justify ? 'No se justifica' : 'Se justifica';
        }
      } else {
        text += this.justify ? 'Se justifica' : 'No se justifica';
      }

      return text;
    },
    determinationClass() {
      const isTransportacion =
        this.id === this.peiAssistantsNeeds.transportacion;

      if (isTransportacion) {
        if (!this.hasAnsweredTransportationQuestions) {
          return 'not-justified'; // valor por defecto mientras no ha respondido ninguna pregunta
        }
        return this.justify ? 'not-justified' : 'justified';
      } else {
        return this.justify ? 'justified' : 'not-justified';
      }
    },
    hasAnsweredTransportationQuestions() {
      return this.transportationQuestions?.every(
        (item) => item.submittedAnswerTypeId !== 0
      );
    },
    canScrollToQuestion() {
      return (
        this.id === 0 &&
        this.hasAdditionalQuestions &&
        this.additionalQuestions.some((question) => question.id === 25) &&
        this.$root.$route?.query &&
        this.$root.$route?.query?.section === 'I' &&
        this.$root.$route?.query?.questionId === '25'
      );
    },
  },
  async mounted() {
    if (!this.transportationQuestions?.length) {
      await this.getTransportationQuestions();
    }
  },
  activated() {
    // scroll to additional questoins if has condition is met
    this.scrollToAdditionalQuestions();
  },
  watch: {
    triggerScroll: {
      immediate: true,
      handler(value) {
        if (value) {
          this.scrollToAdditionalQuestions();
        }
      },
    },
  },
  methods: {
    resetQuestionState(questionItem) {
      if (!questionItem) return;

      questionItem.submittedAnswerTypeId = null;
      questionItem.submittedComment = null;
      questionItem.documentModel = null;
      questionItem.uploadDocumentPanel = false;
      questionItem.submittedDocument = null;
    },
    resetHiddenAdditionalQuestionsBeforeSave() {
      const sourceQuestions = this.allAdditionalQuestions?.length
        ? this.allAdditionalQuestions
        : this.additionalQuestions;

      if (!sourceQuestions?.length) return;

      const visibleQuestionIds = this.additionalQuestions.map(
        (questionItem) => questionItem.id
      );

      sourceQuestions.forEach((questionItem) => {
        if (!visibleQuestionIds.includes(questionItem.id)) {
          this.resetQuestionState(questionItem);
        }
      });
    },
    clearQueryParams() {
      // Clear query params without navigating if already at /pei/detail
      const { path } = this.$root.$route;
      if (
        path === '/pei/detail' &&
        Object.keys(this.$root.$route.query).length > 0
      ) {
        // Replace only if there are params to clear
        this.$root.$router.replace({ path, query: {} });
      } else {
        this.$root.$router.query = {};
      }
    },
    async scrollToAdditionalQuestions() {
      if (this.additionalQuestions.length > 0 && this.canScrollToQuestion) {
        const _this = this;
        let element = [...$('.tab-container-questions')].findLast((x) => x);
        setTimeout(() => {
          _this.scrollTo(element, 130);
        }, 1000);
        this.clearQueryParams();
      }
    },
    scrollTo(element, scrollPixels) {
      if (!element) return;

      $('html, body').animate(
        {
          scrollTop: $(element).offset().top - scrollPixels,
        },
        1000
      );
      this.isOpen = true;
    },
    async onSaveAdditionalQuestions() {
      this.resetHiddenAdditionalQuestionsBeforeSave();

      const payload = this.additionalQuestions.map((questionItem) => ({
        id: questionItem.submittedId,
        peiId: this.selectedPeiId,
        questionServiceNeedId: questionItem.id,
        answerTypeId: questionItem.submittedAnswerTypeId,
        document: questionItem.documentModel,
        comment: questionItem.submittedComment,
      }));
      await this.saveAnswers(payload);
      this.ShowToast('Su información ha sido guardada', '', 'success');
    },
    open() {
      this.isOpen = !this.isOpen;
    },
    deleteClick() {
      this.$emit('delete');
    },
    async onSaveHandler({ answers, isJustified, peiCode }) {
      await this.saveAnswers(answers);

      if (this.justifiedFlagChanged(isJustified)) {
        this.onJustifiedNeedChange({
          peiCode,
          isJustified,
        });
      }

      await this.getTransportationQuestions();
    },
    async saveAnswers(answers) {
      const formData = new FormData();
      (answers || []).forEach((item, index) => {
        formData.append(`answersDto[${index}].id`, item.id ?? '');
        formData.append(`answersDto[${index}].peiId`, item.peiId ?? '');
        formData.append(
          `answersDto[${index}].questionServiceNeedId`,
          item.questionServiceNeedId ?? ''
        );
        formData.append(
          `answersDto[${index}].answerTypeId`,
          item.answerTypeId ?? ''
        );
        formData.append(`answersDto[${index}].document`, item.document ?? '');
        formData.append(`answersDto[${index}].comment`, item.comment ?? '');
      });

      try {
        await needsService.saveQuestions(formData);
        this.ShowToast('Su información ha sido guardada', '', 'success');
      } catch (err) {
        if (err?.response?.data?.message.includes('documento anejado')) {
          this.ShowAlertModal('Alerta', err.response.data.message, 'error', '');
        } else {
          this.ShowToast(
            '',
            err?.response?.data?.message || err?.message,
            'error'
          );
        }
      }
    },
    onJustifiedNeedChange({ peiCode, isJustified }) {
      const payload = {
        peiId: this.selectedPeiId,
        peiCode,
        justifiedFlag: isJustified,
      };
      this.$emit('on-justified-flag-change', payload);
    },
    async getTransportationQuestions() {
      const _questions = await needsService.getQuestions({
        peiId: this.selectedPeiId ?? this.peiId,
        peiCodeId: this.peiAssistantsNeeds.transportacion,
      });
      this.transportationQuestions = _questions.map((questionItem) => ({
        ...questionItem,
        documentModel: null,
        uploadDocumentPanel: !!questionItem?.submittedDocument?.documentId,
        possibleAnswers: questionItem.possibleAnswers.filter((item) =>
          [AnswerType.Yes, AnswerType.No].includes(item.id)
        ),
      }));
    },
  },
};
</script>

<style scoped lang="scss">
.card-container {
  position: relative;
  background-color: #f7f7f7;
  height: 50px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  z-index: 1;
}
.color-icon-plus {
  color: #2db782;
}
.custom-design {
  font-size: 28px;
}
.rounded-circle {
  text-align: center;
  width: 28px;
  height: 28px;
  background: #ffffff 0% 0% no-repeat padding-box;
  opacity: 1;
}
.card-left {
  display: flex;
  align-items: center;
}

.card-right {
  display: flex;
  align-items: end;
}

.pill-justification {
  border-radius: 50px;
  text-align: center;
  height: 29px;
  width: 242px;
  padding: 2px;
  margin: 32px;
}

.justified {
  background-color: #cef7e2; /* Color para "Se Justifica" */
}

.not-justified {
  background-color: #ffd6d6; /* Color para "No se justifica" */
}
</style>
